// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2iEaP","calendarButtons":"ClockData_calendarButtons__aOfU5"};